import { Card, Col, Form, Row } from "antd";
import RHFTextField from "../../components/RHF/RHFTextField";
import RHFTextArea from "../../components/RHF/RHFTextArea";

const StepTwo: React.FC = () => {
  return (
    <Card style={{ marginTop: "35px" }}>
      <Form layout="vertical">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <RHFTextField
              formItemProps={{
                label: "Section Name",
              }}
              inputProps={{}}
              controllerProps={{
                name: `name`,
              }}
              rules={{ required: "This field is required" }}
            />
          </Col>
          <Col span={24}>
            <RHFTextArea
              formItemProps={{
                label: "Description",
              }}
              textAreaProps={{}}
              controllerProps={{
                name: `description`,
              }}
            />
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default StepTwo;
